require '../common/underscore_mixins'
require '../common/backbone_init'
require '../common/jquery_plugin_init'

BrowseApplication = require '../../modules/browse/frontend/application'
TrackingHelper = require '../../modules/browse/frontend/helpers/tracking'
BackToTop = require '../../modules/browse/frontend/views/back_to_top'
ThirdPartyAdsView = require '../../modules/third_party_ads/frontend/views/third_party_ads'
BrowsePageEvents = require '../../modules/browse/frontend/page_events'

# initialize a tracking class to record useful information for trackinghub
Groupon.BrowseTracking = new TrackingHelper()

$(document).ready ->
  $('body').removeClass 'no-js'

  Groupon.browseApp = new BrowseApplication
    isLeftBarVisible: !!Groupon.RefinementBar.isLeftBarVisible
    isOnNoDealsPage: !!Groupon.onNoDealsPage
    goodsBrowsePageLayoutValue: Groupon.goodsBrowsePageLayoutValue
    inNewHomepage: !!Groupon.enabledFeatures?.inNewHomepage
    carouselConfig: Groupon.carouselConfig if !!Groupon.enabledFeatures?.inNewHomepage
    homeWidgetPreview: Groupon.homeWidgetPreview if !!Groupon.enabledFeatures?.inNewHomepage
    showFreeShippingModal: !!Groupon.showFreeShippingModal
    selectedCategory: Groupon.Categories.selectedCategory
    isSeoEnabled: !!Groupon.isSeoEnabled
    isVanityUrl: !!Groupon.isVanityUrl
    inRAPI: !!Groupon.inRAPI
    collection: Groupon.collection
    showClearanceWidget: !!Groupon.showClearanceWidget
    dealTileAds: Groupon.dealTileAds
    useNewGAPIConnector: Groupon.useNewGAPIConnector

  Groupon.browseApp.startApp()
  BackToTop.render()

$(window).load ->
  Groupon.BrowseTracking.pageReady()
  BrowsePageEvents.trigger 'pageReady'
  ThirdPartyAdsView.hideDealTileIfAdBlocked() if Groupon.browseApp.dealTileAds?.inDealTileAds
